import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from '../../redux/store';
import { getLevels, upsertLevels } from '../../redux/slices/settings';
import styles from '../../Components/EditDiv/EditDiv.module.css';
import buttonStyles from '../../Components/YesNoButtonsCSS/YesNoButtons.module.css';
import BlueLogo from '../../assets/BlueLogo.png';

function LevelsRatesPopup({ onClose }) {
  const dispatch = useDispatch();
  const { levels, isLevelsLoading } = useSelector((state) => state.settings);

  const [rows, setRows] = useState([]);
  const [error, setError] = useState('');
  

  useEffect(() => {
    dispatch(getLevels());
  }, [dispatch]);

  useEffect(() => {
    if (Array.isArray(levels)) {
      setRows(
        levels.map((l) => ({
          id: l.id ?? l.level_id ?? undefined,
          level: String(l.level ?? l.name ?? ''),
          salary: Number(l.salary ?? 0),
          internal_rate: Number(l.internal_rate ?? l.internalRate ?? 0),
          external_rate: Number(l.external_rate ?? l.externalRate ?? 0),
        }))
      );
    }
  }, [levels]);

  const handleChange = (index, field, value) => {
    setRows((prev) => {
      const newRows = [...prev];
      const current = { ...newRows[index] };
      if (field === 'level') {
        current.level = value;
      } else {
        const num = value === '' ? '' : Number(value);
        current[field] = Number.isNaN(num) ? 0 : num;
      }
      newRows[index] = current;
      return newRows;
    });
  };

  const addRow = () => {
    setRows((prev) => [
      ...prev,
      { id: undefined, level: '', salary: 0, internal_rate: 0, external_rate: 0 },
    ]);
  };

  const removeRow = (index) => {
    setRows((prev) => prev.filter((_, i) => i !== index));
  };

  const hasInvalid = useMemo(() => {
    return rows.some((r) => !r.level || r.level.trim() === '');
  }, [rows]);

  const handleSave = async () => {
    setError('');
    if (hasInvalid) {
      setError('Level name is required for all rows.');
      return;
    }
    await dispatch(upsertLevels(rows));
    onClose?.();
  };

  

  const renderHeader = () => (
    <div style={{ marginTop: '0', marginBottom: '6px', width: '100%' }}>
      <p style={{ fontWeight: 'bold', fontSize: '16px', color: '#3C96D4', borderBottom: '1px solid #e0e0e0', paddingBottom: '5px' }}>
        Levels, Salaries & Rates
      </p>
    </div>
  );

  return (
    <div className={styles.backGround} style={{ position: 'fixed', alignItems: 'flex-start' }}>
      <div className={styles.form} style={{ width: '720px' }}>
        <div className={styles.momentTitle}>MOMENT</div>
        <div className={styles.sectionTitle}>Manage Levels & Rates</div>

        <div style={{ background: '#fff8e1', border: '1px solid #ffe082', color: '#8a6d3b', padding: '10px 12px', borderRadius: '6px', margin: '10px 0' }}>
          Changing salary and rate data can impact FBP. After updates, please ensure FBP is up to date in the hidden panel.
        </div>

        {renderHeader()}

        {error && (
          <div style={{ color: 'red', marginBottom: '10px', textAlign: 'center' }}>{error}</div>
        )}

        <div style={{ width: '100%', overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #e0e0e0' }}>Level</th>
                <th style={{ textAlign: 'right', padding: '8px', borderBottom: '1px solid #e0e0e0' }}>Salary</th>
                <th style={{ textAlign: 'right', padding: '8px', borderBottom: '1px solid #e0e0e0' }}>Internal Rate</th>
                <th style={{ textAlign: 'right', padding: '8px', borderBottom: '1px solid #e0e0e0' }}>External Rate</th>
                {/* action column removed: no deletion */}
              </tr>
            </thead>
            <tbody>
              {isLevelsLoading ? (
                <tr>
                  <td colSpan={4} style={{ padding: '16px', textAlign: 'center' }}>Loading...</td>
                </tr>
              ) : rows.length === 0 ? (
                <tr>
                  <td colSpan={4} style={{ padding: '16px', textAlign: 'center', color: '#777' }}>No levels yet. Add your first row.</td>
                </tr>
              ) : (
                rows.map((row, idx) => (
                  <tr key={idx}>
                    <td style={{ padding: '6px 8px' }}>
                      <input
                        className={styles.Comment}
                        style={{ height: '20px', width: '100%' }}
                        value={row.level}
                        onChange={(e) => handleChange(idx, 'level', e.target.value)}
                        placeholder="Please enter a new level"
                      />
                    </td>
                    <td style={{ padding: '6px 8px', textAlign: 'right' }}>
                      <input
                        className={styles.Comment}
                        style={{ height: '20px', width: '120px', textAlign: 'right' }}
                        type="number"
                        value={row.salary}
                        onChange={(e) => handleChange(idx, 'salary', e.target.value)}
                      />
                    </td>
                    <td style={{ padding: '6px 8px', textAlign: 'right' }}>
                      <input
                        className={styles.Comment}
                        style={{ height: '20px', width: '120px', textAlign: 'right' }}
                        type="number"
                        value={row.internal_rate}
                        onChange={(e) => handleChange(idx, 'internal_rate', e.target.value)}
                      />
                    </td>
                    <td style={{ padding: '6px 8px', textAlign: 'right' }}>
                      <input
                        className={styles.Comment}
                        style={{ height: '20px', width: '120px', textAlign: 'right' }}
                        type="number"
                        value={row.external_rate}
                        onChange={(e) => handleChange(idx, 'external_rate', e.target.value)}
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '12px' }}>
          <div className={styles.updateButton} onClick={addRow}>
            <div className={buttonStyles.YesButtonComponentStyling}>ADD ROW</div>
          </div>
        </div>

        {/* Job Titles moved to standalone popup */}

        <div className={styles.updateAndCancel}>
          <div className={styles.updateButton} onClick={handleSave}>
            <div className={buttonStyles.YesButtonComponentStyling}>SAVE</div>
          </div>
          <div className={styles.cancelButton} onClick={onClose}>
            <div className={buttonStyles.NoButtonComponentStyling}>CANCEL</div>
          </div>
        </div>

        <img className={styles.blueLogo} src={BlueLogo} alt="BlueLogo" />
      </div>
    </div>
  );
}

export default LevelsRatesPopup;


